import "@babel/polyfill"

require("tb-icons/lib/styles/tb-icons.css")
require("react-id-swiper/src/styles/css/swiper.css")

import * as React from "react"
import { render } from "react-dom"
import * as i18n from "tb-i18n"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import Loadable from "react-loadable"
import MyLoadingComponent from "./loading/index"
import { getGlobalConfig } from "../lib/global-config"
import { domReady } from "../lib/dom-ready"
const AgilePage = Loadable({
    loader: () => import("./agile/agileManagement.component"),
    loading: MyLoadingComponent
})

const Homepage = Loadable({
    loader: () => import("./homepage/homepage.component"),
    loading: MyLoadingComponent
})

const Tourpage = Loadable({
    loader: () => import("./tour/tour.component"),
    loading: MyLoadingComponent
})

const RetailPage = Loadable({
    loader: () => import("./retail/retail.component"),
    loading: MyLoadingComponent
})

const ManagementPage = Loadable({
    loader: () => import("./management/management.component"),
    loading: MyLoadingComponent
})

const SecuritiesPage = Loadable({
    loader: () => import("./securities/securities.component"),
    loading: MyLoadingComponent
})

const ManufacturePage = Loadable({
    loader: () => import("./manufacture/manufacture.component"),
    loading: MyLoadingComponent
})

const EducationPage = Loadable({
    loader: () => import("./education/education.component"),
    loading: MyLoadingComponent
})

const TestPage = Loadable({
    loader: () => import("./test/test.component"),
    loading: MyLoadingComponent
})

const PMpage = Loadable({
    loader: () => import("./pm/pm.component"),
    loading: MyLoadingComponent
})

const Marketpage = Loadable({
    loader: () => import("./market"),
    loading: MyLoadingComponent
})

const Designpage = Loadable({
    loader: () => import("./design"),
    loading: MyLoadingComponent
})

const Hrpage = Loadable({
    loader: () => import("./hr"),
    loading: MyLoadingComponent
})

const start = () => {
    try {
        const mountNode = document.getElementById("mount-node")
        const el = document.getElementById("global-config")
        if (!mountNode) {
            throw new Error("Mount node is not existed.")
        }
        if (!el) {
            throw new Error("el is not existed.")
        }

        // set i18n
        const currentLang = getGlobalConfig().lang
        i18n.setLocales(currentLang, getGlobalConfig().locales)
        i18n.setLanguage(currentLang)

        render(
            <Router>
                <Switch>
                    <Route exact={ true } path="/" component={ Homepage } />
                    <Route path="/tour" component={ Tourpage } />
                    <Route path="/pm" component={ PMpage } />
                    <Route path="/agile" component={ AgilePage } />
                    <Route path="/retail" component={ RetailPage } />
                    <Route path="/manageproject" component={ ManagementPage } />
                    <Route path="/securities" component={ SecuritiesPage } />
                    <Route path="/manufacture" component={ ManufacturePage } />
                    <Route path="/education" component={ EducationPage } />
                    <Route path="/testing" component={ TestPage } />
                    <Route path="/marketing" component={ Marketpage } />
                    <Route path="/design" component={ Designpage } />
                    <Route path="/hr" component={ Hrpage } />
                </Switch>
            </Router>,
            mountNode
        )
    } catch (error) {
        console.error(error)
    }
}

if (process.env.NODE_ENV !== "production") {
    console.log("Looks like we are in development mode!")
}

domReady(start, start)
